import { PerformanceCard } from '@/components/PerformanceCard';
import { TotalReturnDetails } from '@/components/PerformanceCardsContainer/components/TotalReturnDetails';
import {
  useTaskAutomationsPerformance,
  useTaskTotalReturn,
} from '@/modules/Tasks/queries/use-get-task-automations-performance';
import { formatNumber } from '@/utils';
import { useState } from 'react';
import { DateRange } from 'react-day-picker';
import { useTranslation } from 'react-i18next';

type TaskTotalReturnCardProps = {
  taskId: number;
  automationPerformanceDateRange?: DateRange;
};

export const TaskTotalReturnCard = ({
  taskId,
  automationPerformanceDateRange,
}: TaskTotalReturnCardProps) => {
  const { t } = useTranslation();
  const [dateRange, setDateRange] = useState<DateRange>();
  const [searchInput, setSearchInput] = useState<string>();
  const [isDetailsOpen, setDetailsOpen] = useState(false);

  const { data: taskPerformance, isLoading } = useTaskAutomationsPerformance({
    taskId,
    dateRange: automationPerformanceDateRange,
  });

  const {
    data: totalReturnAutomated,
    isLoading: isLoadingTotalReturnAutomated,
    fetchNextPage,
    isFetching,
    isFetchingNextPage,
  } = useTaskTotalReturn({
    taskId,
    enabled: isDetailsOpen,
    dateRange,
    filter: searchInput,
  });

  return (
    <>
      <PerformanceCard
        key={t('total_return')}
        title={t('total_return')}
        content={[
          {
            title: `${formatNumber(taskPerformance?.totalReturn || 0)}€`,
          },
          {
            title: `${formatNumber(taskPerformance?.averageCost ?? 0)}€`,
            subtitle: t('average_return_per_run'),
          },
        ]}
        isLoading={isLoading}
        onExpand={() => setDetailsOpen(true)}
      />
      {isDetailsOpen && (
        <TotalReturnDetails
          isLoading={isLoadingTotalReturnAutomated}
          totalReturnAutomated={totalReturnAutomated}
          onClose={() => setDetailsOpen(false)}
          excludeSearchInput
          fetchNextPage={fetchNextPage}
          dateRange={dateRange}
          setDateRange={setDateRange}
          setSearchInput={setSearchInput}
          isFetching={isFetching}
          isFetchingNextPage={isFetchingNextPage}
        />
      )}
    </>
  );
};
